import { render, staticRenderFns } from "./ThirdPartyApps.vue?vue&type=template&id=0b9cbf23&scoped=true&"
import script from "./ThirdPartyApps.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyApps.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyApps.vue?vue&type=style&index=0&id=0b9cbf23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9cbf23",
  null
  
)

export default component.exports